import { Component, computed, inject, input, signal } from '@angular/core';
import { InvoiceGridService } from '../../invoice-grid.service';
import { CommonModule } from '@angular/common';
import { MDContentBoxComponent, MDDropDownComponent, MDIconComponent, IMDDropDownOption } from '@melodic-ui/components';
import { ClickOutsideDirective } from '@lb/directives';
import { InvoiceStateService } from '@lb/state/invoice-state.service';
import { formatInvoiceDate } from '../../invoice-date-time.formatter';
import { FormFieldComponent } from '@lb/components/form/form-field/form-field.component';

@Component({
	selector: 'lb-invoice-pay-period-filter',
	templateUrl: './invoice-pay-period-filter.component.html',
	styleUrls: ['./invoice-pay-period-filter.component.scss'],
	standalone: true,
	imports: [CommonModule, MDIconComponent, MDContentBoxComponent, MDDropDownComponent, ClickOutsideDirective, FormFieldComponent]
})
export class InvoicePayPeriodFilterComponent {
	private readonly invoiceGridService = inject(InvoiceGridService);
	private readonly invoiceStateService = inject(InvoiceStateService);

	isAdmin = input.required<boolean>();

	isOpen = signal(false);

	selectedPayPeriodID = computed(() => this.invoiceGridService.filters().payPeriodID);
	selectedIsCurrentPayPeriod = computed(() => this.invoiceGridService.filters().isCurrentPayPeriod);

	payPeriodOptions = computed<IMDDropDownOption[]>(() =>
		this.invoiceStateService.payPeriods().map((period) => ({
			label: `${formatInvoiceDate(period.periodStartDate)} - ${formatInvoiceDate(period.periodEndDate)}`,
			value: period.payPeriodID
		}))
	);

	clearFilterSelectedOptions(): void {
		this.invoiceGridService.updateFilters({ payPeriodID: undefined, isCurrentPayPeriod: undefined });
	}

	setPayPeriod(payPeriodID: unknown): void {
		this.invoiceGridService.updateFilters({ payPeriodID: payPeriodID as number });
		this.isOpen.set(false);
	}

	setCurrentPayPeriod(event: Event): void {
		const isChecked = (event.target as HTMLInputElement).checked;
		this.invoiceGridService.updateFilters({ isCurrentPayPeriod: isChecked || undefined });
	}
}
